// Whether Re:Vault should keep its branding out of sight: the name is hidden, Quick hide is set
// up, a tab cloak or about:blank is on, or maximum obfuscation is picked. Anything decorative and
// branded (the start page bumper) stays off while this is true. get = the settings getter.
// build.mjs has the same rule in the pre-paint (BUMPER_PREPAINT); test/bumpers.test.mjs keeps them equal.
export function brandQuiet(get) {
	return (
		get("showBrand") === false ||
		get("panicEnabled") === true ||
		(get("cloakPreset") || "none") !== "none" ||
		get("cloakOnBlur") === true ||
		get("aboutBlank") === true ||
		get("obfuscation") === "max"
	);
}

// Whether the start page shows a bumper at all.
export const bumperOn = (get) => get("bumpers") !== "off" && !brandQuiet(get);
